import React, { useRef } from 'react';
import Accordion from 'ui/components/atoms/Accordion';
import useImpressionNCP from '../../../hooks/emarsys/new-car-purchase/useImpressionNCP';
import useImpressionCouponService from '../../../hooks/emarsys/coupon-service/useImpressionCouponService';
import useImpressionCouponServiceList from '../../../hooks/emarsys/coupon-service/useImpressionCouponServiceList';
import { IBreadcrumbs } from '../Breadcrumbs';
import useImpressionPackageService from '../../../hooks/emarsys/package-service/useImpressionPackageService';
import useImpressionPackageServiceList from '../../../hooks/emarsys/package-service/useImpressionPackageServiceList';
import useImpressionProductKnowledgeList from '../../../hooks/emarsys/product-knowledge/useImpressionProductKnowledgeList';
import useImpressionNewsList from '../../../hooks/emarsys/news/useImpressionNewsList';
import useImpressionAccessories from '../../../hooks/emarsys/accessories/useImpressionAccessories';

export interface IFaq {
  question: string;
  answer: string;
}
export interface FaqAccordionProps {
  faqs: IFaq[];
  title?: string;
  classTitle?: string;
  containerClassname?: string;
  headingClassName?: string;
  divClassName?: string;
  classNameChildrenWrapper?: string;
  isCMS?: boolean;
  impressionData?: {
    title?: string;
    carModel?: string;
    pageTitle: string;
    menu?: string;
    breadcrumbItems?: IBreadcrumbs[];
    category?: string;
    page_number?: number;
    sku?: string;
    skuPrice?: string;
    carModels?: string[];
  };
  feature?: string;
}

const FaqAccordion = ({
  faqs,
  title = '',
  classTitle,
  containerClassname = 'my-10 lg:my-20',
  headingClassName = '',
  divClassName = '',
  classNameChildrenWrapper = '',
  isCMS = false,
  impressionData = {
    title: '',
    carModel: '',
    pageTitle: '',
    menu: '',
    breadcrumbItems: [],
    category: '',
    page_number: 0,
  },
  feature = '',
}: FaqAccordionProps) => {
  const impressionRef = useRef(null);

  if (feature === 'NCP_PDP') {
    useImpressionNCP(
      impressionRef,
      impressionData.title,
      impressionData.pageTitle,
      impressionData.carModel,
      impressionData.menu
    );
  } else if (feature === 'COUPON_SERVICE') {
    useImpressionCouponService(
      impressionRef,
      impressionData.pageTitle,
      impressionData.breadcrumbItems,
      'faq kupon servis toyota'
    );
  } else if (feature === 'COUPON_SERVICE_LIST') {
    useImpressionCouponServiceList(
      impressionRef,
      impressionData?.pageTitle,
      impressionData?.breadcrumbItems,
      'faq kupon servis toyota',
      impressionData?.carModels
    );
  } else if (feature === 'PACKAGE_SERVICE') {
    useImpressionPackageService(
      impressionRef,
      impressionData.pageTitle,
      impressionData.breadcrumbItems,
      'faq paket servis'
    );
  } else if (feature === 'PACKAGE_SERVICE_LIST') {
    useImpressionPackageServiceList(
      impressionRef,
      impressionData?.pageTitle,
      impressionData?.breadcrumbItems,
      'faq paket servis toyota',
      impressionData?.carModels
    );
  } else if (feature === 'LISTING_PRODUCT_KNOWLEDGE') {
    useImpressionProductKnowledgeList(
      impressionRef,
      impressionData.pageTitle,
      impressionData.category,
      impressionData.page_number,
      'faq review'
    );
  } else if (feature === 'NEWS_LIST') {
    useImpressionNewsList(
      impressionRef,
      impressionData.pageTitle,
      impressionData.category,
      impressionData.page_number,
      'faq tips toyota'
    );
  } else if (feature === 'ACCESSORIES_INFO') {
    useImpressionAccessories(
      impressionRef,
      impressionData.pageTitle,
      impressionData.breadcrumbItems,
      impressionData.sku,
      impressionData.skuPrice,
      title || 'faq aksesoris & spareparts toyota',
      impressionData.carModels
    );
  }

  return (
    <section className={`${containerClassname}`} ref={impressionRef}>
      <div className={`container xl:px-0 ${divClassName}`}>
        {title && (
          <h2
            id="branch-faq"
            className={`text-base mb-3 text-reliableBlack font-bold uppercase lg:text-2xl ${headingClassName}`}
          >
            {title}
          </h2>
        )}

        {faqs?.map((faq, idx) => (
          <Accordion
            key={`accordion-${idx}`}
            title={faq.question}
            index={String(idx + 1)}
            classTitle={classTitle}
            isCMS={isCMS}
            classNameChildrenWrapper={classNameChildrenWrapper}
          >
            {faq.answer}
          </Accordion>
        ))}
      </div>
    </section>
  );
};

export default FaqAccordion;
